import { useId } from "react";

export function useFieldIds(name: string) {
  const reactId = useId();
  const base = `${name}-${reactId}`;

  return {
    inputId: `${base}-input`,
    labelId: `${base}-label`,
    hintId: `${base}-hint`,
    errorId: `${base}-error`,
    describedBy: (hasHint: boolean, hasError: boolean) =>
      [hasHint && `${base}-hint`, hasError && `${base}-error`]
        .filter(Boolean)
        .join(" "),
  };
}
